/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from "react";
import axios from "axios";
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalBody,
} from "@chakra-ui/modal";
import Card from "components/card";
import { Button } from '@chakra-ui/react';

const RequestWhitelistAddressApproveConfirmModal: React.FC<{
    dataToApprove: any;
    isOpen: boolean;
    onClose(): void;
    triggerReload(): void;
    setSwalProps: any;
}> = ({ isOpen, onClose, triggerReload, dataToApprove, setSwalProps }) => {

    const [isProcessing, setIsProcessing] = useState<boolean>(false);
    const userRole = localStorage.getItem("userRole");

    const closeModal = async () => {
        onClose();
    };

    const handleSubmit = async () => {
        try {
            setIsProcessing(true);

            const data = {
                username: localStorage.getItem("username"),
                userRole: userRole,
                subaccount_id: dataToApprove.subaccount.id,
                wlad_id: dataToApprove.wlad_id,
                address: dataToApprove.address,
                subaccountName: dataToApprove.subaccount.name,
                network: dataToApprove.network,
                asset: dataToApprove.asset,
                status: "1"
            }

            await axios.post(process.env.REACT_APP_API_URL + `/api/${userRole.toLowerCase()}/trade/action/update-whitelist-address-status`, data)
                .then(function (response) {
                    if (response && response.data?.status === 'ok') {
                        closeModal();
                        setSwalProps({
                            show: true,
                            icon: "success",
                            title: "Success",
                            html: "Whitelist address request has been approved",
                            showConfirmButton: true,
                            didClose: () => {
                                triggerReload();
                                setSwalProps({});
                                setIsProcessing(false);
                            },
                        });
                    } else {
                        setIsProcessing(false);
                    }
                })
                .catch(function (error) {
                    setIsProcessing(false);
                    setSwalProps({
                        show: true,
                        icon: "error",
                        title: "Oops!",
                        html: error.response.data.message,
                        showConfirmButton: true,
                        didClose: () => {
                            setSwalProps({});
                            setIsProcessing(false);
                        },
                    });
                });
        } catch (error: any) {
            setIsProcessing(false);
            setSwalProps({
                show: true,
                icon: "error",
                title: "Oops!",
                html: "Something went wrong, please try again later.",
                showConfirmButton: true,
                didClose: () => {
                    setSwalProps({});
                    setIsProcessing(false);
                },
            });
        }
    };

    const formatDate = (timestamp: string) => {
        if (!timestamp) return "-";
        const date = new Date(parseInt(timestamp));
        return date.toLocaleString();
    };

    const formatStatus = (status: string) => {
        return status.charAt(0).toUpperCase() + status.slice(1);
    };

    return (
        <>
            {dataToApprove &&
                <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
                    <ModalOverlay className="bg-[#000] !opacity-30" />
                    <ModalContent className="dark:!bg-neutral-900 !z-[1002] !m-auto !w-full max-w-2xl !rounded-2xl !border !border-gray-200 !bg-white !shadow-xl dark:!border-white/10 md:!top-[12vh]">
                        <ModalBody className="p-6 md:p-7">
                            <div className="mb-4 flex items-start gap-3">
                                <div className="rounded-xl bg-green-50 p-2 text-green-600 ring-1 ring-green-100 dark:bg-green-900/20 dark:text-green-400 dark:ring-green-900/30">
                                    <svg
                                        viewBox="0 0 24 24"
                                        className="h-5 w-5"
                                        fill="currentColor"
                                    >
                                        <path d="M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z" />
                                    </svg>
                                </div>
                                <div>
                                    <h1 className="text-lg font-semibold text-gray-900 dark:text-white">
                                        Approve Whitelist Address Request
                                    </h1>
                                    <p className="mt-1 text-sm text-gray-600 dark:text-gray-300">
                                        Confirm approval of this address
                                    </p>
                                </div>
                            </div>

                            <div className="mb-4 rounded-xl border border-green-200 bg-green-50 px-4 py-3 text-sm text-green-800 dark:border-green-900/40 dark:bg-green-900/20 dark:text-green-300">
                                You're about to approve this request. This action cannot be undone.
                            </div>

                            <div className="dark:bg-neutral-800/50 mb-6 rounded-xl bg-gray-50 p-4 ring-1 ring-gray-100 dark:ring-white/10">
                                <div className="flex flex-col gap-3 text-sm">
                                    <div className="flex">
                                        <div className="w-40 shrink-0 text-gray-700 dark:text-gray-400">
                                            Nickname
                                        </div>
                                        <div className="font-medium text-gray-900 dark:text-white">
                                            {dataToApprove.nickname}
                                        </div>
                                    </div>

                                    <div className="flex">
                                        <div className="w-40 shrink-0 text-gray-700 dark:text-gray-400">
                                            Address
                                        </div>
                                        <div className="break-all font-medium text-gray-900 dark:text-white">
                                            {dataToApprove.address}
                                        </div>
                                    </div>

                                    <div className="flex">
                                        <div className="w-40 shrink-0 text-gray-700 dark:text-gray-400">
                                            Asset
                                        </div>
                                        <div className="font-medium text-gray-900 dark:text-white">
                                            {dataToApprove.asset}
                                        </div>
                                    </div>

                                    <div className="flex">
                                        <div className="w-40 shrink-0 text-gray-700 dark:text-gray-400">
                                            Network
                                        </div>
                                        <div className="font-medium text-gray-900 dark:text-white">
                                            {dataToApprove.network}
                                        </div>
                                    </div>

                                    <div className="flex">
                                        <div className="w-40 shrink-0 text-gray-700 dark:text-gray-400">
                                            Merchant
                                        </div>
                                        <div className="font-medium text-gray-900 dark:text-white">
                                            {dataToApprove.merchant.name}
                                        </div>
                                    </div>

                                    <div className="flex">
                                        <div className="w-40 shrink-0 text-gray-700 dark:text-gray-400">
                                            Subaccount
                                        </div>
                                        <div className="font-medium text-gray-900 dark:text-white">
                                            {dataToApprove.subaccount.name}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="flex justify-end gap-2">
                                <Button
                                    onClick={() => closeModal()}
                                    isDisabled={isProcessing}
                                    className="dark:bg-neutral-900 dark:hover:bg-neutral-800 rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary-500/20 dark:border-white/10 dark:text-white"
                                >
                                    Not now
                                </Button>

                                <Button
                                    onClick={() => handleSubmit()}
                                    isDisabled={isProcessing}
                                    isLoading={isProcessing}
                                    loadingText='Processing...'
                                    className="rounded-lg bg-green-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-500 focus:outline-none focus:ring-2 focus:ring-green-500/30 disabled:cursor-not-allowed disabled:bg-gray-400"
                                >
                                    Approve request
                                </Button>
                            </div>
                        </ModalBody>
                    </ModalContent>
                </Modal>
            }
        </>
    );
};

export default RequestWhitelistAddressApproveConfirmModal;